module.exports = __webpack_public_path__ + "assets/img/icon_record.842ba175.svg";